import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Monogram, NAV } from "./Header";

export const Footer = () => {
  const { settings } = useApp();
  return (
    <footer data-testid="site-footer" className="relative bg-[#142419] text-stone-300 grain overflow-hidden">
      <div className="container-fv py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Monogram className="!h-14 !w-16" />
          <p className="f-display text-2xl text-stone-100 mt-5">Hacienda Fernández &amp; Vargas</p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed">Genética Brangus criada a campo, con pasión, datos y excelencia.</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow !text-[#C5A059] mb-4">Secciones</p>
          <ul className="space-y-2 text-sm">
            {NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="hover:text-[#C5A059] transition-colors">{n.label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4 space-y-3 text-sm">
          <p className="eyebrow !text-[#C5A059] mb-4">Contacto</p>
          <p className="flex gap-3" data-testid="footer-phone"><Phone size={16} className="text-[#C5A059] mt-0.5" />{settings.phone}</p>
          <p className="flex gap-3" data-testid="footer-email"><Mail size={16} className="text-[#C5A059] mt-0.5" />{settings.email}</p>
          <p className="flex gap-3" data-testid="footer-address"><MapPin size={16} className="text-[#C5A059] mt-0.5" />{settings.address}</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-fv py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-stone-500">
          <span>© {new Date().getFullYear()} Hacienda Fernández &amp; Vargas</span>
          <Link to="/admin/login" data-testid="nav-admin-login-button" className="hover:text-[#C5A059]">Acceso administración</Link>
        </div>
      </div>
    </footer>
  );
};
